function AnchorTag(url: any, title: any) {
  return <a href={url} target="_blank" rel="noreferrer">{title}</a>;
}
export default AnchorTag;
